// useUpdateOnFocus.ts
import { AppState, Platform } from "react-native";
import UseUpdates from "./UseUpdates";
import Bugsnag from "@bugsnag/expo";
import { useEffect } from "react";

export const useUpdateOnFocus = () => {
  // don't run at all on web...
  if (Platform.OS === "web") return;

  // Warm start logic: listen to app state changes and check
  // for updates when the app becomes active.
  useEffect(() => {
    const subscription = AppState.addEventListener(
      "change",
      async (nextAppState) => {
        if (nextAppState === "active") {
          console.log("[UseFakeSplash] ****** Warm start ******");

          await checkForUpdateAndApply();
        }
      }
    );

    // Cleanup subscription on unmount
    return () => subscription.remove();
  }, []);
};

/**
 * Check for an OTA update and apply it if found.
 **/
export async function checkForUpdateAndApply() {
  if (Platform.OS === "web") return false;

  const { isUpdateAvailable, checkForAndApplyUpdateAsync } = UseUpdates();

  Bugsnag.leaveBreadcrumb("[UseFakeSplash] checking for update");
  const updateAvailable = await isUpdateAvailable();

  if (updateAvailable) {
    Bugsnag.leaveBreadcrumb("[UseFakeSplash] update is available");
    await checkForAndApplyUpdateAsync();
    Bugsnag.leaveBreadcrumb("[UseFakeSplash] update applied");
    return true;
  } else {
    Bugsnag.leaveBreadcrumb("[UseFakeSplash] update not available");
    return false;
  }
}
